import classnames from 'classnames';

// 被第三方嵌入
export const isThreePartEmbed = window.parent !== window.top;

// 顶层页与当前页跨域 = 被第三方站点 iframe 嵌入
// 读 window.top.location.origin 抛 SecurityError 是跨域的权威信号；
// 把 origin 作为比较条件使用（而不是 void 掉），避免 webpack/terser 把
// `void window.top.location.origin` 当作无用表达式优化掉，导致 try 块无法命中跨域抛错路径。
export const isThirdPartyIframe = (() => {
  if (window === window.top) return false;
  try {
    return window.top.location.origin !== window.location.origin;
  } catch {
    return true;
  }
})();

// 对外错误 code，与 space-gateway 的 postMessage 契约对齐
export const CS_ERROR_CODE_UNAUTHORIZED = 40301;

/**
 * 向第三方发送`token`失效消息
 */
export function sendMsg(data = {}) {
  if (isThreePartEmbed) {
    window.top?.postMessage({ type: 'cloudstudio', ...data }, '*');
  }
}

/**
 * 向嵌入我们 iframe 的父窗口发送错误事件，供接入方感知并自定义处理。
 * 消息体顶层字段与 space-gateway static/*.html 保持一致：type/code/messages/traceId。
 */
export function postCloudStudioError({ code, messages, traceId }) {
  if (window === window.top) return;
  window.top?.postMessage(
    {
      type: 'cloudStudioError',
      code,
      messages: messages || '',
      traceId: traceId || '',
    },
    '*',
  );
}

// getMode Params
export const getMode = () => {
  const search = new URLSearchParams(location.search);
  return search.get('mode');
};

// add club cls
export const addClubCls = (styles, key, addon) => {
  return classnames({
    [styles[key]]: true,
    [styles[`${key}-club`]]: !!getMode(),
    [styles[`${key}-${addon}-club`]]: !!addon && !!getMode(),
  });
};
